/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../../core";
import { SheetConfig } from "../../../../sheets/types/SheetConfig";
export const Blueprint = core.serialization.object({
    slug: core.serialization.string(),
    name: core.serialization.string(),
    primary: core.serialization.boolean().optional(),
    sheets: core.serialization.list(SheetConfig),
});
